import React, { useEffect, useState } from 'react';
import CustomCard from '../CustomCard';
import FormGenerator from './FormGenerator';
import { Button } from 'react-bootstrap';
import ConfirmModal from '../modal/ConfirmModal';
import { Actions } from '../../../client/Actions';
import QrCodeButton from '../qrCode/QrCodeButton';
import EditButton from '../button/EditButton';
import { useLoader } from '../loader/useLoader';
import Form from './Form';
import { useLoaderContext } from '../loader/LoaderContext';

const CardFormNew = ({
  fields,
  id,
  qrCodeField,
  qrCodeValue,
  api,
  editApi,
  title,
  shadow,
  performReload,
  initialData,
  additional,
  withoutCancel,
  customSave,
  customCancel,
  disableCleanAfterSave,
  customClean,
  reInit,
  className,
  withoutPadding,
  readOnly,
  withToggle,
  editable,
  onInvalid,
  postSaved,
  onToggleChange,
  reverseButtons,
  saveButton,
  dictionaries,
  replaceFormData,
  withoutHeader,
  onRemoveField,
  noActions,
  formDataChanged,
  createFormDataFrom,
  postCancel,
  executeSave,
  executeCancel,
  disableInvalidAlert,
  disableLoader,
  width = 6,
}) => {
  const { loader, setLoader } = useLoaderContext();

  const [hideBody, setHideBody] = useState(withToggle);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState();
  const [ready, setReady] = useState(false);
  const [alertInvalid, setAlertInvalid] = useState(false);
  const [showAllerModal, setShowAllerModal] = useState(false);
  const [qrCodeReady, setQrCodeReady] = useState(false);
  const [loadedData, setLoadedData] = useState();

  const saveData = () => {
    if (!disableLoader) {
      setLoader(true);
    }
    if (editMode) {
      Actions.put(editApi || api + '/' + id, formData, onSaved, undefined, setLoader);
    } else {
      if (customSave) {
        customSave(formData, onSaved);
      } else {
        Actions.post(api, formData, onSaved);
      }
    }
  };

  const handleSave = () => {
    if (!ready) {
      setAlertInvalid(true);
      if (onInvalid) {
        onInvalid();
      }
      if (!disableInvalidAlert) {
        setShowAllerModal(true);
      }
    } else {
      saveData();
    }
  };

  const onSaved = (saved) => {
    if (postSaved) {
      postSaved(saved);
    }

    if (customClean) {
      setFormData(customClean(formData));
      setAlertInvalid(false);
    } else if (!disableCleanAfterSave) {
      clearData();
    }

    if (editMode) {
      setEditMode(false);

      if (id) {
        setLoadedData(undefined);
      } else {
        reInit();
      }
    }

    if (performReload) {
      performReload();
    }

    setLoader(false);
  };

  const onCancel = () => {
    if (editMode) {
      setEditMode(false);
      reInit();
    } else {
      clearData();
    }

    if (postCancel) {
      postCancel();
    }
  };

  const clearData = () => {
    setFormData(undefined);
    setAlertInvalid(false);
  };

  const calculateQrCodeReady = () => {
    const result =
      !!qrCodeValue ||
      (!!qrCodeField &&
        !!formData &&
        !!formData[qrCodeField] &&
        formData[qrCodeField] !== '');

    setQrCodeReady(result);
  };

  useEffect(calculateQrCodeReady, [formData, qrCodeValue]);
  useEffect(() => {
    if (formDataChanged && !readOnly) {
      formDataChanged(formData);
    }
  }, [formData]);

  useEffect(() => {
    if (createFormDataFrom) {
      setFormData(createFormDataFrom);
    }
  }, [createFormDataFrom]);

  useEffect(() => {
    if (onToggleChange) {
      onToggleChange(!hideBody);
    }

    if (hideBody && editMode) {
      onCancel();
    }
  }, [hideBody]);

  useEffect(() => {
    if (!!executeSave) {
      handleSave();
    }
  }, [executeSave]);

  useEffect(() => {
    if (!!executeCancel) {
      onCancel();
    }
  }, [executeCancel]);

  useEffect(() => {
    if (replaceFormData) {
      setFormData(replaceFormData);
    }
  }, [replaceFormData]);

  useEffect(() => {
    console.log('id && !loadedData');
    if (id && !loadedData) {
      setEditMode(true);
      loadById();
    }
  }, [id, loadedData]);

  function dataByIdLoaded(data) {
    setLoadedData(data);
    setLoader(false);
  }

  function loadById() {
    setLoader(true);
    Actions.get(api + '/' + id, dataByIdLoaded);
  }

  function prepareTittle() {
    return (
      <div className={'d-flex justify-content-between align-content-center'}>
        <div className="float-left mw-85 align-content-center">{title}</div>
        {withToggle ? (
          <div className="float-right ms-2">
            <Button
              variant={'outline-primary'}
              onClick={() => setHideBody(!hideBody)}
              className="accordion-button"
            >
              {!hideBody ? (
                <i className="fas fa-chevron-circle-up text-primary h5"></i>
              ) : (
                <i className="fas fa-chevron-circle-down text-primary h5"></i>
              )}
            </Button>
          </div>
        ) : (
          ''
        )}
        {withToggle && !hideBody && (
          <div className="float-right">
            {editable && !editMode && (
              <EditButton onClick={() => setEditMode(true)} value={!editMode} />
            )}
            {(qrCodeField || qrCodeValue) && (
              <QrCodeButton
                disabled={!qrCodeReady}
                value={
                  qrCodeValue || (formData ? formData[qrCodeField] : undefined)
                }
              />
            )}
          </div>
        )}

        {!withToggle && (
          <div className="float-right">
            {editable && !editMode && (
              <EditButton onClick={() => setEditMode(true)} value={!editMode} />
            )}
            {(qrCodeField || qrCodeValue) && (
              <QrCodeButton
                disabled={!qrCodeReady}
                value={
                  qrCodeValue || (formData ? formData[qrCodeField] : undefined)
                }
              />
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <CustomCard
        title={prepareTittle()}
        shadow={shadow}
        className={className}
        hideBody={hideBody}
        withoutPadding={withoutPadding}
        withoutHeader={withoutHeader}
        width={width}
      >
        <Form {...{
          fields,
          id,
          api,
          editApi,
          initialData,
          additional,
          readOnly,
          editable,
          dictionaries,
          onInvalid,
          formDataChanged,
          postSaved,
          onRemoveField,
          disableInvalidAlert,
          replaceFormData,
          createFormDataFrom,
          noActions,
          saveButton,
          customSave,
          disableCleanAfterSave,
          customClean,
          onCancel,
          reInit,
          shadow,
          withToggle,
          performReload,
          executeSave,
          executeCancel,
          className,
          width,
          formData,
          setFormData,
          setReady,
          alertInvalid
        }} />

      </CustomCard>


    </>
  );
};

export default CardFormNew;
